module.exports = __webpack_public_path__ + "img/russia.9ccc56af.png";